"use client";

import { motion } from "framer-motion";

export const MessageLoadingSquare = () => {
  return (
    <div className="shrink-0 p-0.5">
      <motion.div
        className="size-3 rounded-full bg-ring"
        animate={{
          scale: [1, 1.3, 1],
          opacity: [0.4, 1, 0.4],
        }}
        transition={{
          duration: 1.5,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />
    </div>
  );
};
